/* Ian | 2026-01-12
   Globally open external links in a new tab
*/
document.addEventListener('DOMContentLoaded', function () {
  const siteOrigin = 'https://eribewholesale.com'

  document.querySelectorAll('a[href]').forEach(link => {
    const href = link.getAttribute('href')

    if (href && href.startsWith('http') && !href.startsWith(siteOrigin)) {
      link.setAttribute('target', '_blank')
      link.setAttribute('rel', 'noopener noreferrer')
    }
  })
})